
export default function GestureDirective(directiveName) {
    return ['$ionicGesture', '$parse', function($ionicGesture, $parse) {
        var eventType = directiveName.substr(2).toLowerCase();

        return function(scope, element, attr) {
            var fn = $parse( attr[directiveName] );

            var listener = function(ev) {
                scope.$apply(function() {
                    fn(scope, {
                        $event: ev
                    });
                });
            };

            var gesture = $ionicGesture.on(eventType, listener, element);

            scope.$on('$destroy', function() {
                $ionicGesture.off(gesture, eventType, listener);
            });
        };
    }];
}



// WEBPACK FOOTER //
// ./src/modules/core/util/gesture-directive.js